<template>
    <footer class="footer">
        <ul class="nav">
            <li class="nav-item">
                <a href="https://startreming.com" class="nav-link">
                    Startreming
                </a>
            </li>
            <li class="nav-item">
                <a href="mailto:support@startreming.com" class="nav-link">
                    Contact
                </a>
            </li>
        </ul>
    </footer>
</template>
<script>
    export default {
        name: 'footerInfo'
    }
</script>
